import { gql } from "@apollo/client";

export const SIGNUP_PORTAL_USER_MUTATION = gql`
  mutation SignupPortalUser(
    $name: String!
    $email: String!
    $login: String!
    $password: String!
    $verificationToken: String!
  ) {
    signupPortalUser(
      name: $name
      email: $email
      login: $login
      password: $password
      verificationToken: $verificationToken
    ) {
      id
      name
      email
      login
    }
  }
`;